import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import { validateClearanceWizard, validateUniqueValue } from "../../util/validations/ClearanceWizardValidation";
import { pagingTotalRelation, userPrefType } from "../Types";
import { trimSearchQuery } from "../../util/CommonFunc";
import { appConfig } from "App";
module = "/mlLic/forms/";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
  CLEAR_ERRORS: "CLEAR_ERRORS" + module,
  FOCUS_ITEM: "FOCUS_ITEM" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  QUERY: "QUERY" + module,
  EDIT_ITEM: "EDIT_ITEM" + module,
  POSTING: "POSTING" + module,
  POST_OK: "POSTOK" + module,
  POST_ERROR: "POST_ERROR" + module,
  RECENT_LOADING: "RECENT_LOADING" + module,
  RECENT_LOAD: "RECENT_LOAD" + module,
  RECENT_ERROR: "RECENT_LOAD" + module,
  RECENT_QUERY: "RECENT_QUERY" + module,
  REFRESH_ITEMS: "REFRESH_ITEMS" + module,
  LAST_REFRESH: "LAST_REFRESH" + module,
  IS_ALLOCATED_OPEN: "IS_ALLOCATED_OPEN" + module,
  LOAD_HISTORY: "LOAD_HISTORY" + module,
  REMOVE_HISTORY: "REMOVE_HISTORY" + module,
  VALIDATING: "VALIDATING" + module,
  VALIDATING_OK: "VALIDATING_OK" + module,
  VALIDATING_ERROR: "VALIDATING_ERROR" + module,
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};

export const refreshItems = (items) => (dispatch) => {


 
  dispatch({
    type: actionTypes.REFRESH_ITEMS,
    payload: items,
  });
};

export const setLastRefresh = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.LAST_REFRESH,
    payload: items,
  });
};

export const setIsAllocatedSectionOpen = (state) => (dispatch) => {
  dispatch({
    type: actionTypes.IS_ALLOCATED_OPEN,
    payload: state,
  });
};

export const removeHistory = (cfId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY,
    payload: cfId,
  });
};


export const getFormHistory = (cfId, done = null) => (dispatch) => {
  //   if (done) done({}, null);
  // }
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  // dispatch({
  //   type: actionTypes.POSTING,
  //   payload: message,
  // });

  axios
    .post(`${orgID}/mllic/forms/searchHistory`, { cfId: cfId }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.LOAD_HISTORY,
        payload: {
          cfId:cfId,
          history:res.data
        }
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      // dispatch({
      //   type: actionTypes.POST_ERROR,
      //   // payload: { e: err },
      //   payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      // });

      // if (done) done(null, err.response?.data?.name == 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const postItem = (action, message, items, done = null) => async (dispatch) => {
 
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  if (action === "saveform" && items.cf) {
    let errors = await validateClearanceWizard(items.cf);
    if (errors) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: errors
      });
      if (done) done(null, errors);
      return;
    }
    if(items.cf.fieldsToValidate){
      delete items.cf.fieldsToValidate;
    }
  }

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();


  axios
    .post(`${orgID}/mllic/forms/${action}`, items, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        // payload: { e: err },
        payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      });

      if (done) done(null, err.response?.data?.name == 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};

export const setRecentCFQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.RECENT_QUERY,
    payload: query,
  });

  if (done) done();
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};
export const search = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .post(`${orgID}/mllic/forms/search`, trimSearchQuery(query), {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const searchCFRecent = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.RECENT_LOADING,
  });

  axios
    .post(`${orgID}/mllic/forms/searchRecent`, query, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.RECENT_LOAD,
          payload: res.data.results,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.RECENT_ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const updateSearchUserPref = (pref, message, done = null) => (
  dispatch
) => {
  const {
    user: { id },
  } = store.getState();
  const tId = uuidv4();
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(
      `${id}/userpref/update`,
      { type: userPrefType.CLERANCEFORMSPREF, pref: pref },
      {
        headers: { tid: tId },
      }
    )
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const clearErrors = (param = "", done = null) => (dispatch) => {

  const {
    mllicform: { posting },
  } = store.getState();
  
  if(param && posting.errors){
    let headerq = appConfig.CLEARANCE.CF_HEADER_FIELD_LIST.filter(f=> f.id === param) || [];

    if(posting.errors[param]){
      delete posting.errors[param];    
    }
    
    if(headerq.length > 0 && headerq[0].subQuestions && headerq[0].subQuestions.length > 0){
      headerq[0].subQuestions.forEach(e => {
        delete posting.errors[e.id];
      });
    }

    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: {...posting.errors},
    });
  } 
  else if(!param){
    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: {},
    });
  }

  if (done) done();
};

export const checkUniqueValue = (field, value, cfId, done = null) => async (dispatch) =>{

  dispatch({
    type: actionTypes.VALIDATING,
    payload: "Validating...",
  });

  let isUnique = await validateUniqueValue(field, value, cfId) ?? false;

  if(isUnique){
    clearErrors(field.id);
    dispatch({
      type: actionTypes.VALIDATING_OK,
    });

  }else{
    dispatch({
      type: actionTypes.VALIDATING_ERROR,
      payload: {[field.id]: `${field.label} already in use`},
    });
  }
}
